// src/api_scripts/createEntryPoint.js
import { createApiClient } from "../apiClient";

const createEntryPoint = async (entryPointData, orgId, accessToken, setProgress) => {
  const { name } = entryPointData.name;

  setProgress((prev) => [
    ...prev,
    { type: 'info', message: `Attempting to create Entry Point: "${name}"...`, timestamp: new Date().toLocaleTimeString() }
  ]);
  

  // API endpoint for creating a new Entry Point
  const relativeUri = `organization/${orgId}/entry-point`;

  try {
    const apiClient = createApiClient(accessToken);
    const response = await apiClient.post(relativeUri, entryPointData);

    const newEntryPoint = response.data; // The API returns the created resource directly

    console.log("Create Entry Point API Response Data:", newEntryPoint);

    setProgress((prev) => [
      ...prev,
      { type: 'success', message: `Successfully created Entry Point "${name}" (ID: ${newEntryPoint.id}).`, timestamp: new Date().toLocaleTimeString() }
    ]);

    return newEntryPoint.id; // Return the created Entry Point object (includes its ID)

  } catch (error) {
    console.error(`Error creating Entry Point "${name}":`, error);

    let errorMessage = `Error creating Entry Point "${name}": ${error.message || String(error)}`;

    if (error.response && error.response.data) {
      if (error.response.data.error && error.response.data.error.reason) {
        errorMessage += ` (Reason: ${error.response.data.error.reason})`;
      } else if (error.response.data.message) {
        errorMessage += ` (Detail: ${error.response.data.message})`;
      } else if (typeof error.response.data === 'string') {
        errorMessage += ` (Response: ${error.response.data})`;
      }
    }

    setProgress((prev) => [
      ...prev,
      { type: 'error', message: errorMessage, timestamp: new Date().toLocaleTimeString() }
    ]);
    throw error;
  }
};

export default createEntryPoint;
